module.exports = __webpack_public_path__ + "img/84.4ff44750.jpg";